import { BoxProps, TextNewProps } from '@jfs/ui-new'
import { shadowStyle } from '../../../../util/util'

const styles = {
  superParent: {
    f: 1,
  } as BoxProps,
  maincontainer: {
    padding: 16,
    flex: 1,
    overflow: 'auto',
    backgroundColor: 'BACKGROUND',
  } as BoxProps,
  container: {
    ...shadowStyle,
    overflow: 'hidden',
    paddingBottom: 20,
    paddingTop: 10,
    paddingHorizontal: 16,
    backgroundColor: 'WHITE',
    borderColor: 'GRAY_BORDER',
  } as BoxProps,
  heading: {
    fontSize: 18,
    fontWeight: '500',
    fontFamily: 'jiotype-medium',
    color: 'BLACK_21',
  } as TextNewProps,
  headingContainer: {
    pl: 5,
    pt: 15,
  } as BoxProps,
  formBox: {
    marginTop: 20,
  } as BoxProps,
  centerAlign: {
    f: 1,
    justify: 'center',
  } as BoxProps,
}
export { styles }
